import { useState, useEffect, useCallback } from 'react'
import { useAuth } from './useAuth'
import { teamApi } from '@/lib/api'

export function useTeam() {
  const { user, loading: authLoading } = useAuth()
  const [team, setTeam] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchTeam = useCallback(async () => {
    if (!user?.id) {
      return
    }

    try {
      setLoading(true)
      setError(null)

      const { team: data } = await teamApi.getCurrent()
      setTeam(data)
    } catch (err) {
      if (err.status !== 404) {
        setError(err.message)
      }
      setTeam(null)
    } finally {
      setLoading(false)
    }
  }, [user?.id])

  useEffect(() => {
    if (authLoading) {
      setLoading(true)
      return
    }

    if (!user?.id) {
      setTeam(null)
      setLoading(false)
      return
    }

    fetchTeam()
  }, [user?.id, authLoading, fetchTeam])

  const refetch = useCallback(() => {
    fetchTeam()
  }, [fetchTeam])

  return {
    team,
    loading,
    error,
    refetch,
    hasTeam: !!team,
  }
}

